import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAdminAuthStateChanged } from '../../utils/auth';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const unsubscribe = onAdminAuthStateChanged((user) => {
      if (user) {
        setAuthed(true);
      } else {
        navigate('/admin/login', { replace: true });
      }
      setChecking(false);
    });
    return unsubscribe;
  }, [navigate]);

  if (checking) return null;
  if (!authed) return null;
  return children;
};

export default ProtectedRoute;
